import { TextColorProps, TextFontProps } from "./commonProps";
import { textColorClassName, textFontClassName, transitionClassName } from "./commonClassNames";

export type SpanProps = React.HTMLAttributes<HTMLSpanElement> &
  TextColorProps &
  TextFontProps & {
    selectNone?: boolean;
    wrap?: boolean;
    italic?: boolean;
  };

export const Span: React.FC<SpanProps> = ({
  children,
  black,
  currentColor,
  font,
  green,
  neutral,
  onClick,
  primary,
  red,
  selectNone,
  size = "base",
  transparent,
  underline,
  uppercase,
  white,
  wrap,
  yellow,
  italic,
  className,
  ...props
}) => {
  const generatedClassName = [
    className,
    ...(italic ? ["italic"] : []),
    typeof onClick === "undefined" ? "" : "cursor-pointer",
    "px-1",
    wrap ? "whitespace-wrap" : "whitespace-nowrap",
    selectNone ? "select-none" : "",
    textColorClassName({
      currentColor,
      black,
      primary,
      white,
      neutral,
      yellow,
      green,
      red,
      transparent,
    }),
    textFontClassName({ font, uppercase, underline, size }),
    transitionClassName({ colors: true }),
  ].join(" ");

  return (
    <span {...props} className={generatedClassName} onClick={onClick}>
      {children}
    </span>
  );
};
